import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import { memo, useMemo } from 'react'

interface Props {
  amenity: App.PackageRoomAmenity
}

function VillasPageAmenity({ amenity }: Props) {
  const inclusion = useMemo<App.OfferInclusion>(() => ({
    id: amenity.id,
    description: amenity.description,
    symbol: amenity.symbol,
  }), [amenity])

  return <OfferInclusionItem inclusion={inclusion} format="titlecase" />
}

export default memo(VillasPageAmenity)
